import { KeyedObject } from '../types';
import _               from 'underscore';


export const runIfFunction = ( ...params: any[] ) => {

    let [ method, ...args ] = params;

    if( typeof method == 'function' ) return method.apply( null, args ?? [] );
}

export const runIfFunctionAsync = async ( ...params: any[] ) => {

    return await runIfFunction( ...params )
}

export function promisedTimeout( ms: number ){
    return new Promise( resolve => setTimeout( resolve, ms ) );
}

export function arrayMove( arr: any[], old_index: number, new_index: number ){

    while( old_index < 0 ){
        old_index += arr.length;
    }
    while( new_index < 0 ){
        new_index += arr.length;
    }
    if( new_index >= arr.length ){
        var k = new_index - arr.length + 1;
        while( k-- ){
            arr.push( undefined );
        }
    }
    arr.splice( new_index, 0, arr.splice( old_index, 1 )[ 0 ] );

    return arr; // for testing purposes
}

export function getKeyByValue( object: KeyedObject, value: any ): string[]{

    return Object.keys( object ).filter( key => object[ key ] === value );
}

export const arraysAreEqual = function( arr1: Array<string | number>, arr2: Array<string | number> ){

    return arr1.sort().toString() === arr2.sort().toString();
}

export const arrayToggleValueInOut = function <T>( arr: Array<T>, value: T, includedTestMethod: ( value: T ) => boolean = undefined ){

    if( _.isNull( value ) || _.isUndefined( value ) || _.isObject( value ) ) return arr;

    const result = ( _.isFunction( includedTestMethod ) ? !includedTestMethod( value ) : arr.includes( value ) )
                   ? _.without( arr, value )
                   : [ ...arr, value ];

    return result;
}

export const pointIsInsideRect = (
    point: { x: number, y: number },
    rect: { left: number, right: number, top: number, bottom: number }
): boolean => (
    ( point.x > rect.left ) &&
    ( point.x < rect.right ) &&
    ( point.y > rect.top ) &&
    ( point.y < rect.bottom )
);

// Reduces a collection's key set when keys have null / undefined values. Does not remove empty array or string values.
export const pickNonFalsy = ( collection: object ) => _.pick( collection, _.identity );

export const getKeyFromMapValue = ( map: Map<any, any>, valueSearch: any ) => {
    return [ ...map ].find( ( [ key, value ] ) => valueSearch === value )[ 0 ];
}
